import type { RegisterUserArgs } from '../../api/types/user.types';

import { registerUserWithPassword } from '../../api';
import { useMutation } from '../base';

export default function useCreateAccount() {
  const { data, isPending, mutateAsync } = useMutation({
    mutationFn: async (args: RegisterUserArgs) =>
      registerUserWithPassword(args),
  });

  return {
    data,
    isPending,
    mutateAsync,
  };
}
